import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Ctx = createContext(null);
export const useComp = () => useContext(Ctx);

export function CompProvider({ children }) {
  const [meta, setMeta] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/compliance/me").then((r) => setMeta(r.data)).catch(() => setErr(true)); }, []);
  if (err) return <p className="p-6 text-sm text-rose-600">Module indisponible.</p>;
  if (!meta) return null;
  return <Ctx.Provider value={meta}>{children}</Ctx.Provider>;
}

export const DOT = { green: "bg-emerald-500", orange: "bg-amber-500", red: "bg-rose-500", grey: "bg-gray-300", blue: "bg-sky-500" };
export const PILL = { green: "bg-emerald-50 text-emerald-700", orange: "bg-amber-50 text-amber-700", red: "bg-rose-50 text-rose-700",
  grey: "bg-gray-100 text-gray-500", blue: "bg-sky-50 text-sky-700" };
export const SEV_C = { mineure: "bg-gray-100 text-gray-600", majeure: "bg-amber-50 text-amber-700", critique: "bg-rose-100 text-rose-700" };
export const NC_C = { ouverte: "bg-rose-50 text-rose-700", en_cours: "bg-amber-50 text-amber-700", corrigee: "bg-sky-50 text-sky-700", cloturee: "bg-emerald-50 text-emerald-700" };
export const BTN = "rounded-full bg-[#065F46] text-white hover:bg-[#047857]";
export const daysTxt = (d) => (d == null ? "" : d < 0 ? `${-d} j de retard` : d === 0 ? "aujourd'hui" : `dans ${d} j`);

export function StatusPill({ ob, testid }) {
  const m = useComp();
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${PILL[ob.color] || PILL.grey}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${DOT[ob.color] || DOT.grey}`} />{m.statuses[ob.effective_status] || ob.effective_status}
    </span>
  );
}

export function Field({ label, children, className = "" }) {
  return <div className={className}><p className="mb-1 text-xs font-medium text-gray-500">{label}</p>{children}</div>;
}

export function Sel({ value, onChange, options, testid, empty, className = "" }) {
  const entries = Array.isArray(options) ? options : Object.entries(options);
  return (
    <Select value={value || "__none"} onValueChange={(v) => onChange(v === "__none" ? "" : v)}>
      <SelectTrigger data-testid={testid} className={`rounded-xl ${className}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        {empty && <SelectItem value="__none">{empty}</SelectItem>}
        {entries.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
